import { Alert, Button } from '@mui/material';
import React from 'react';
import { translateKey } from 'src/locales/translate';
import { DosageAutofillNotice, dosageAutofillMessage } from './dosageAutofill';
import { SPAN_FULL } from './medicationFormLayout';

interface DosageAutofillAlertProps {
  notice: DosageAutofillNotice;
  /** "Wyczyść podpowiedź": takes back what the autofill filled. */
  onClear: () => void;
  /** The host holds the form (unconfirmed or saving). */
  disabled?: boolean;
}

/** Says where the prefilled dose came from, above the dosage fields (#692). */
export default function DosageAutofillAlert({
  notice,
  onClear,
  disabled,
}: DosageAutofillAlertProps): React.ReactElement {
  return (
    <Alert
      severity="info"
      sx={SPAN_FULL}
      data-testid="medication-dosage-autofill"
      action={
        <Button
          color="inherit"
          size="small"
          disabled={disabled}
          onClick={onClear}
          data-testid="medication-dosage-autofill-clear"
        >
          {translateKey('medication.form.autofillClear')}
        </Button>
      }
    >
      {dosageAutofillMessage(notice)}
    </Alert>
  );
}
